import { makeStylesV5 } from '../index';
export default makeStylesV5()((theme) => ({
    dialogTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 20,
        lineHeight: '24px',
        fontWeight: 500,
        padding: 16,
        '& .close-icon': {
            marginLeft: 'auto'
        }
    },
    dialogContent: {
        display: 'flex',
        alignItems: 'center',
        padding: '20px 16px',
        '& .dialog-content-text': {
            fontSize: 14,
            lineHeight: '20px',
            color: theme.palette.common.black
        }
    },
    dialogActions: {
        padding: '20px 16px',
    }
}));
//# sourceMappingURL=styles.js.map